
var displayedFeaturedEvents = [];

(function($, undefined) {
	
	'use strict';
    var currPage;
    var searchEventsInput;
    var searchEventsBtn;
    var searchInputAndDropDownCtn;
    var searchDropDown;
    var searchDropDownChoiceOuterCtn;
    var searchDropDownChoiceInnerCtn;
    var searchEventsSliderBtn;
    var featureBtn;
    var removeChosenFeaturedBtn;
    var sendLostTicketsBtn;
    var lang = $('html').attr('lang');

    var displayedEvents = [];
    
    var searchEvents = function() {
        var t = $(this);
        var searchVal = encodeInputText(t.closest(".input-and-inner-btn-ctn").find(searchEventsInput).val());
        var parentCtn = searchEventsInput.closest(".lost-tickets-option-content");
        $(".search-events-lost-tickets input").val(searchVal);
        $(".input-form-lost-tickets-search").val(searchVal);
        var dropDownDisplayedEvents = parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item');
        if (searchVal !== '') {
            parentCtn.find(searchDropDown).slideDown(300);
            ajax('/action/epSearchEvents?q=' + searchVal + '&count=99999999&ajax=true', function(response) {
                var json = JSON.parse(response);
                var newResults = [];

                if (json.length > 0) {
                    $.each(json, function(k, v) {
                        var id = json[k].id;
                        newResults.push(id);

                        if ($.inArray(id, displayedEvents) === -1) {
                            populateDropDown(parentCtn, json[k], false, false);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedEvents, newResults);
                    displayedEvents = newResults;


                    parentCtn.find(searchDropDownChoiceOuterCtn).slideDown(300);
                } else {
                    parentCtn.find(searchDropDownChoiceOuterCtn).slideUp(300);
                    emptyDropDown(dropDownDisplayedEvents);
                }
            },true);
        } else {
            parentCtn.find(searchDropDown).slideUp(300);
            emptyDropDown(dropDownDisplayedEvents);
        }
    };
    
    var searchEventsSlider = function() {
        var t = $(this);
        var searchVal = encodeInputText(t.closest(".input-and-inner-btn-ctn").find(searchEventsInput).val());
        var parentCtn = t.closest(".lost-tickets-option-content");
        $(".search-events-lost-tickets input").val(searchVal);
        $(".input-form-lost-tickets-search").val(searchVal);
        var dropDownDisplayedEvents = parentCtn.find(searchDropDownChoiceInnerCtn).find('.search-drop-down-one-item');
        
        if (searchVal !== '') {
            parentCtn.find(searchDropDown).slideDown(300);
            ajax('/action/epSearchEvents?q=' + searchVal, function(response) {
                var json = JSON.parse(response);
                var newResults = [];
                if (json.length > 0) {
                    $.each(json, function(k, v) {
                        var id = json[k].id;
                        newResults.push(id);
                        
                        if ($.inArray(id, displayedEvents) === -1) {
                            populateDropDown(parentCtn, json[k], true, false);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedEvents, newResults);
                    displayedEvents = newResults;


                    parentCtn.find(searchDropDownChoiceOuterCtn).slideDown(300);
                } else {
                    parentCtn.find(searchDropDownChoiceOuterCtn).slideUp(300);
                    emptyDropDown(dropDownDisplayedEvents);
                }
            },true);
        } else {
            parentCtn.find(searchDropDown).slideUp(300);
            emptyDropDown(dropDownDisplayedEvents);
        }
    };
    
    var removeUnrelatedProfilesFromDropDown = function(parentCtn, displayedProfiles, newResults) {
        if (displayedProfiles.length > 0 && newResults.length > 0) {
            for (var i = 0; i < displayedProfiles.length; i++) {
                if  ($.inArray(displayedProfiles[i], newResults) === -1) {
                    parentCtn.find('.search-drop-down-one-item#' + displayedProfiles[i]).slideUp(300, function() {
                        $(this).remove();
                    });
                }
            }
        }
    };
    var emptyDropDown = function(events) {
        displayedEvents = [];
        displayedFeaturedEvents = [];
        events.slideUp(300, function() {
            $(this).remove();
        });
    };


    var populateDropDown = function(parentCtn, obj, slider, feature) {
        var id = obj.id;
        var name = encodeText(obj.name);
        var friendlyUrl = parentCtn.attr("data-detail-page")+"/"+obj.friendlyUrl+'?contact=true';
        var date = encodeText(obj.startDate);
        date += obj.startDate !== obj.endDate ? " " : ", ";
        if(obj.startDate === obj.endDate) {
            date += obj.startTime;

            if(obj.displayEndTime === 'true'){
                date += (lang === 'fr') ? " \xE0 " : " to ";
                date += obj.endTime;
            }
        }
        if(obj.startDate !== obj.endDate){
            date += (lang === 'fr') ? " au " : " to ";
            date += encodeText(obj.endDate) + " ";
        }
        var image = obj.profileMediaId !== 0 ? obj.profileMediaId : 0;
        var address=encodeText(obj.address) + ', ' + encodeText(obj.city);
        var dropDownItemCtn = parentCtn.find('.search-drop-down-one-item#clone').clone();
        var mediaId = obj.profileMediaId;
        styleAndAppendClone(dropDownItemCtn, parentCtn.find('.search-drop-down-choices-inner-ctn'), id, name, image, address, friendlyUrl, date, slider, feature, mediaId);

    };

    var styleAndAppendClone = function(clone, container, id, name, image, address, friendlyUrl, date, slider, feature, mediaId) {
        if(!slider && !feature){
            clone.on("click", function() {
                window.location = friendlyUrl;
            });
        }
        clone.find('.search-drop-down-one-item-name').html(name);

        if (date !== '') {
            clone.find('.search-drop-down-one-item-datetime-ctn p').html(date);
        }
        if (image !== "0") {
            clone.find('.bg-pic').css('background-image', 'url(/static/uploaded/EventProfile/' + image + '-profile.jpg)');
        }

        if (address !== '') {
            clone.find('.search-drop-down-one-item-location').html(address);
        }

        if (clone.hasClass('search-drop-down-one-item')) {
            clone.attr('id', id);
        } else {
            clone.find('.search-drop-down-one-item').attr('id', id);
        }
        if(slider){
            clone.on("click", function(){chooseEvent($(this),container.closest(".lost-tickets-option-content"));});
        }
        if(feature){
            clone.attr("data-media-id", mediaId);
            clone.on("click", function(){selectAsFeature($(this),container.closest(".lost-tickets-option-content"));});
        }
        clone.hide().removeClass('clone');
        container.append(clone);
        clone.slideDown(300);
    };
    
    
    var chooseEvent = function(event,parentCtn){
        var cl = event.clone();
        parentCtn.next(".slider-box-theme-ctn").find(".slide-event-selected-ctn").html(cl);
        event.closest(searchDropDown).slideUp();
        parentCtn.next(".slider-box-theme-ctn").find(".event-id-selected").attr("value",cl.attr("id"));
        parentCtn.next(".slider-box-theme-ctn").slideDown();
        parentCtn.next(".slider-box-theme-ctn").next(".event-slide-btns").slideDown();
    };
    var selectAsFeature = function(event,parentCtn){
        var cl = event.clone();
        cl.find(".removable-item-btn").on("click", removeChosenFeature);
        parentCtn.next(".box-theme-ctn").find(".slide-event-selected-ctn").html(cl);
        event.closest('.search-drop-down').slideUp();
        parentCtn.next(".box-theme-ctn").slideDown();
        parentCtn.next(".box-theme-ctn").next(".event-slide-btns").slideDown();
    };
    
    var removeChosenFeature = function(){
        var t = $(this);
        t.closest(".box-theme-ctn").next(".event-slide-btns").slideUp();
        t.closest(".search-drop-down-one-item").slideUp(function(){
            $(this).remove();
        });
        t.closest(".event-select-box").slideUp();
    };
    
    function encodeText(name) {
        if(name !== undefined){
            name = name.replace(/\\xE0/g, '\xE0');
            name = name.replace(/\\xE2/g, '\xE2');
            name = name.replace(/\\xE3/g, '\xE3');
            name = name.replace(/\\xE4/g, '\xE4');
            name = name.replace(/\\xE5/g, '\xE5');
            name = name.replace(/\\xE7/g, '\xE7');
            name = name.replace(/\\xE9/g, '\xE9');
            name = name.replace(/\\xE8/g, '\xE8');
            name = name.replace(/\\xEA/g, '\xEA');
            name = name.replace(/\\xEB/g, '\xEB');
            name = name.replace(/\\xEE/g, '\xEE');
            name = name.replace(/\\xEF/g, '\xEF');
            name = name.replace(/\\xF1/g, '\xF1');
            name = name.replace(/\\xF2/g, '\xF2');
            name = name.replace(/\\xF3/g, '\xF3');
            name = name.replace(/\\xF4/g, '\xF4');
            name = name.replace(/\\xF6/g, '\xF6');
            name = name.replace(/\\xF9/g, '\xF9');
            name = name.replace(/\\xFB/g, '\xFB');
            name = name.replace(/\\xC0/g, '\xC0');
            name = name.replace(/\\xC2/g, '\xC2');
            name = name.replace(/\\xC7/g, '\xC7');
            name = name.replace(/\\xC8/g, '\xC8');
            name = name.replace(/\\xC9/g, '\xC9');
            name = name.replace(/\\xCA/g, '\xCA');
            name = name.replace(/\\xCB/g, '\xCB');
            name = name.replace(/\\xCE/g, '\xCE');
            name = name.replace(/\\xCF/g, '\xCF');
            name = name.replace(/\\xD1/g, '\xD1');
            name = name.replace(/\\xD4/g, '\xD4');
            name = name.replace(/\\xD9/g, '\xD9');
            name = name.replace(/\\xDB/g, '\xDB');
        } else{
            name = "";
        }
        return name;
    }

    function encodeInputText(name) {
        if (name !== undefined) {
            name = name.replace('à', '\xE0');
            name = name.replace('â', '\xE2');
            name = name.replace('ã', '\xE3');
            name = name.replace('ä', '\xE4');
            name = name.replace('å', '\xE5');
            name = name.replace('ç', '\xE7');
            name = name.replace('é', '\xE9');
            name = name.replace('è', '\xE8');
            name = name.replace('ê', '\xEA');
            name = name.replace('ë', '\xEB');
            name = name.replace('î', '\xEE');
            name = name.replace('ï', '\xEF');
            name = name.replace('ñ', '\xF1');
            name = name.replace('ò', '\xF2');
            name = name.replace('ó', '\xF3');
            name = name.replace('ô', '\xF4');
            name = name.replace('ö', '\xF6');
            name = name.replace('ù', '\xF9');
            name = name.replace('û', '\xFB');
            name = name.replace('À', '\xC0');
            name = name.replace('Â', '\xC2');
            name = name.replace('Ç', '\xC7');
            name = name.replace('È', '\xC8');
            name = name.replace('É', '\xC9');
            name = name.replace('Ê', '\xCA');
            name = name.replace('Ë', '\xCB');
            name = name.replace('Î', '\xCE');
            name = name.replace('�?', '\xCF');
            name = name.replace('Ò', '\xD1');
            name = name.replace('Ô', '\xD4');
            name = name.replace('Ù', '\xD9');
            name = name.replace('Û', '\xDB');
        } else {
            name = "";
        }
        return name;
    }
    var checkOutClick = function(event){
        if(!$(event.target).closest('.search-input-and-drop-down-ctn ').length){
           if ($('.search-drop-down-choices-outer-ctn').is(":visible")) {
                $('.search-drop-down').slideUp(300);
            }
        }
    };
    
    
    var searchFeatureEvents = function() {
        var t = $(this);
        var searchVal = encodeInputText(t.closest(".input-and-inner-btn-ctn").find(".lost-tickets-search").val());
        var parentCtn = t.closest(".lost-tickets-option-content");
        var dropDownDisplayedEvents = parentCtn.find('.search-drop-down-choices-inner-ctn').find('.search-drop-down-one-item');
        if (searchVal !== '') {
            parentCtn.find('.search-drop-down').slideDown(300);
            ajax('/action/epSearchEvents?q=' + searchVal, function(response) {
                var json = JSON.parse(response);
                var newResults = [];

                if (json.length > 0) {
                    $.each(json, function(k, v) {
                        var id = json[k].id;
                        newResults.push(id);
                        if ($.inArray(id, displayedFeaturedEvents) === -1) {
                            populateDropDown(parentCtn, json[k],false, true);
                        }
                    });

                    removeUnrelatedProfilesFromDropDown(parentCtn, displayedFeaturedEvents, newResults);
                    displayedFeaturedEvents = newResults;

                    parentCtn.find('.search-drop-down-choices-outer-ctn').slideDown(300);
                } else {
                    parentCtn.find('.search-drop-down-choices-outer-ctn').slideUp(300);
                    emptyDropDown(dropDownDisplayedEvents);
                }
            },true);
        } else {
            parentCtn.find('.search-drop-down').slideUp(300);
            emptyDropDown(dropDownDisplayedEvents);
        }
    };
    
    var sendLostTickets = function(){
        var t = $(this);
        var email = $(".lost-tickets-form").find("input[name=email]").val();
        if(email !== ''){
            t.addClass('disabled');
            var url = "/action/epLostTickets?ajax=true";
            url += "&email="+email;
            
            ajax(url, function(response){
                $(".lost-tickets-no-payments").slideUp();
                $(".lost-tickets-no-tickets").slideUp();
                $(".lost-tickets-sent").slideUp();
                if (response.indexOf("success") !== -1) {
                    $(".lost-tickets-form-inner-ctn").slideUp();
                    $(".lost-tickets-sent").slideDown();
                }
                if (response.indexOf("fail") !== -1) {
                    $(".lost-tickets-no-payments").slideDown();
                }
                if (response.indexOf("no-tickets") !== -1) {
                    $(".lost-tickets-no-tickets").slideDown();
                }
                t.removeClass('disabled');
            }, true);
        }
    };
    
    var init = function(page){
        currPage = $(page);
        searchEventsInput = $('.lost-tickets-search');
        searchEventsBtn = $('.lost-tickets-search-btn');
        searchInputAndDropDownCtn = $('.search-input-and-drop-down-ctn');
        searchDropDown = $('.search-drop-down');
        searchDropDownChoiceOuterCtn = $('.search-drop-down-choices-outer-ctn');
        searchDropDownChoiceInnerCtn = $('.search-drop-down-choices-inner-ctn');
        searchEventsBtn.click(searchEvents);  
        searchEventsSliderBtn = $('.slider-list-event-btn');
        searchEventsSliderBtn.click(searchEventsSlider);
        
        featureBtn = $(".feature-event-btn");
        featureBtn.on("click", searchFeatureEvents);
        
        sendLostTicketsBtn = $(".send-lost-tickets-btn");
        sendLostTicketsBtn.on("click", sendLostTickets);
        
        $(document).on('click',checkOutClick);
        
    };
    
    	
	$(window).on("load",function(){
        init();
    });

})(jQuery);